import { useState } from "react";
import { CreateAttachmentTypeModel } from "@core/model/query-model-attachment-type";
import {
  useQyCreateAttachmentType,
  useQyGetAttachmentType,
} from "@core/query/attachment-type.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export const useFormDropdownAttachmentType = () => {
  const { showWarning, showSuccess } = useNotificationContext();
  const [sidebar, setSidebar] = useState(false);
  const [filter, setFilter] = useState("");
  const [newAttachmentType, setNewAttachmentType] =
    useState<CreateAttachmentTypeModel>({
      name: "",
      description: "",
    });
  const [isCreating, setIsCreating] = useState(false);

  const handleFilterInput = (event: any) => {
    if (event.key === "Enter") {
      setNewAttachmentType({
        name: filter,
        description: "",
      });
      setSidebar(true);
    }
  };
  const handleAdd = () => {
    if (!newAttachmentType.name) {
      showWarning("Please fill in AttachmentType details");
      return;
    }
    setIsCreating(true);
    addAttachmentType(newAttachmentType);
  };

  const handleAddApiSuccess = () => {
    showSuccess(
      "New AttachmentType is added. Check and select the AttachmentType in the form."
    );
    setSidebar(false);
    setIsCreating(false);
  };
  const handleAddApiError = () => {
    setIsCreating(false);
  };
  const { mutate: addAttachmentType } = useQyCreateAttachmentType(
    handleAddApiSuccess,
    handleAddApiError
  );
  const { data: attachmentTypeResponse } = useQyGetAttachmentType("");
  const mappedAttachmentType = (attachmentTypeResponse?.data || []).map(
    (item) =>
      ({
        label: item.name,
        value: item.code,
      } as LabelValue)
  );

  return {
    sidebar,
    filter,
    newAttachmentType,
    mappedAttachmentType,
    isCreating,
    attachmentTypeResponse,
    setSidebar,
    setFilter,
    setNewAttachmentType,
    handleFilterInput,
    handleAdd,
    addAttachmentType,
  };
};
